<template>
  <button @click="setComponent">{{ $t("helpers.chat.contact") }}</button>
</template>

<script>
export default {
  name: "HelpBackComponent",

  methods: {
    setComponent() {
      this.$emit("changeComponent", "Message");
    },
  },
};
</script>

<style lang="scss" scoped>
button {
  background: #0990df;
  border-radius: 8px;
  padding: 6px 12px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  cursor: pointer;
  font-size: 13px;
  color: #ffffff;
  border: transparent;

  &:hover {
    background: #0990df;
  }
}
</style>
